module.exports = __webpack_public_path__ + "media/SWV-I_DW_1_Stellenwerttafel.be4e6246.mp3";